const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_CLIENT_ID,
      region: process.env.REACT_APP_REGION || "ap-south-1",
    }
  }
};

export default awsConfig;